module.exports = __webpack_public_path__ + "img/200w.320db3f9.gif";